import React, { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import Button from "./button";
import { APPLICATION_STATUS } from "../utils/constants";

const AdminRejectAanvraagModal = ({ isOpen, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    const modal = document.getElementById("reject-reason-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }



  useEffect(() => {

  }, []);

  const submitForm = () => {
    if (reason === "") {
        setError("Please enter a reason");
      return;
    }
    setError("");
    onSubmit(reason);
    handleClose();
  };



  return (
    <dialog id="reject-reason-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-lg overflow-y-auto rounded-md bg-white text-ink shadow-overlay">

        <div className="modal-content">

        <button
          type="button"
          aria-label="Sluiten"
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
          onClick={handleClose}
        >
          <FeatherIcon icon="x" size={16} />
        </button>
        <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">
          Reden voor Afgekeurd
        </h1>
        <div
          className="update-profile-form px-6 py-4"
          
        >
          <div className="grid grid-cols-1 gap-4">
            <div>
            <div className="grid grid-cols-1 gap-4">
            <div>
              <textarea
                id="reason"
                name="reason"
                type="text"
                placeholder="Voer de reden voor de afwijzing in"
                rows={8}
                className="block w-full appearance-none rounded border-2 border-line bg-white px-2 py-1.5 text-sm text-ink placeholder:text-ink-subtlest focus:border-brand focus:outline-none"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                {error}
              </div>
            </div>
          </div>
            </div>
          </div>
        
          <div className="mt-4 flex justify-end gap-2">
            <Button btnClassNames="h-8 rounded bg-[#C9372C] px-3 text-sm font-medium text-white hover:bg-[#AE2A19]" text={APPLICATION_STATUS.AFGEKEURD} onClick={()=>submitForm()} />
          </div>
        </div>
        
        </div>
      </div>
    </dialog>
  );
};

export default AdminRejectAanvraagModal;
